import React from 'react';
import fingerprint from './fingerprint.png';
import { Fingerprint, FingerprintRight, Wrapper } from './index.styled';
import { animated, useSpring } from 'react-spring';

export const PortfoliosHero = ( props ) => {

  const leftProps = useSpring({
    delay: 500,
    from: {
      transform: 'translate3d(-200px, 0px, 0px)',
      opacity: 0,
    },
    to: {
      transform: 'translate3d(0px, 0px, 0px)',
      opacity: 1,
    }
  });

  const rightProps = useSpring({
    delay: 500,
    from: {
      transform: 'translate3d(200px, 0px, 0px) rotate(180deg)',
      opacity: 0,
    },
    to: {
      transform: 'translate3d(0px, 0px, 0px) rotate(180deg)',
      opacity: 1,
    }
  });

  return (
        <Wrapper>
          <Fingerprint>
            <animated.img src={fingerprint} alt="" role="presentation" style={leftProps} />
          </Fingerprint>
          <FingerprintRight>
            <animated.img src={fingerprint} alt="" role="presentation" style={rightProps} />
          </FingerprintRight>
        </Wrapper>
  )
}